import { HttpHeaders } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FileUploadModule } from 'primeng/fileupload';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'brt-file-upload',
  standalone: true,
  imports: [FileUploadModule],
  templateUrl: './file-upload.component.html',
  styleUrl: './file-upload.component.css'
})
export class FileUploadComponent {
  constructor(private userService: UserService) {
    userService.current$.subscribe(() => this.updateHeaders());
  }

  ngOnInit() {
    if (!this.businessId && !this.bucket)
      console.error('business-id or bucket is required');
  }

  headers: HttpHeaders;
  async updateHeaders() {
    var token = await this.userService.getToken();
    this.headers = new HttpHeaders()
      .set('Authorization', `Bearer ${token}`);
    // .set('X-BRT-Business-Id', this.businessId);
  }

  @Input('bucket') bucket: string;
  _businessId: string;
  @Input('business-id') set businessId(businessId: string) {
    this._businessId = businessId;
    this.updateHeaders();
  }
  get businessId() { return this._businessId; }
  @Input() chooseLabel: string;
  @Input() accept: string;
  @Input() maxFileSize: number;
  @Input() multiple: boolean;
  @Input() mode: 'advanced' | 'basic' | undefined = 'advanced';
  @Input() auto: boolean = true;
  @Output() onUpload = new EventEmitter<string[]>();
}
